import { render, staticRenderFns } from "./PrintCardsDialog.vue?vue&type=template&id=38e2971f"
import script from "./PrintCardsDialog.vue?vue&type=script&lang=js"
export * from "./PrintCardsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports